'use strict';

var _plugins = require('./plugins');


/*****************
 ** WEBPACK FOOTER
 ** ./~/radium/lib/config.js
 ** module id = 428
 ** module chunks = 1
 **/